export default "__VITE_ASSET__4f7fed80__"